<template>
  <div class="select">
    <titleBar :title="title"></titleBar>
    <div
      v-for="(item, index) in data"
      class="lessonItem"
      @click="godetail(item.detailUrl,item.classNumber,item.courseId)"
    >
      <div class="item">
        <h2>{{item.title}}</h2>
        <div v-if="item.startDate == item.endDate && item.weekdays" class="timeItem">
          <span>{{item.startDate}} 周{{item.weekdays}} {{item.lessonStart}} 开课</span>
        </div>
        <div v-else-if="item.startDate != item.endDate" class="timeItem">
          <span>{{item.startDate}}-{{item.endDate}}</span>
          <span
            v-if="item.weekdays.split('、').length == 7 && item.weekdays"
          >每天 {{item.lessonStart}} 开课</span>
          <span
            v-else-if="item.weekdays.split('、').length > 3 && item.weekdays"
          >每周上课时间：{{item.lessonStart}}</span>
          <span
            v-else-if="item.weekdays.split('、').length <= 3 && item.weekdays"
          >每周{{item.weekdays}} {{item.lessonStart}} 开课</span>
        </div>
        <div v-if="groupId != 1 || item.difficultyStar == 0 || subject == 0" class="diffcult_item">
          <span>难度</span>
          <i v-for="(k, i) in star" :class="[i < item.difficultyStar ? 'on' : 'off']"></i>
        </div>
        <div class="lesson_item_mes">
          <div class="box">
            <img :src="item.lecturer.avatar" />
            <div class="r_box">
              <span class="name">{{item.lecturer.name}}</span>
              <span class="role">主讲</span>
            </div>
          </div>
          <div class="box">
            <img :src="item.adviser.avatar" />
            <div class="r_box">
              <span v-if="item.adviser.name" class="name">{{item.adviser.name}}</span>
              <span v-else class="name">待分配</span>
              <span v-if="item.surplusQuota" class="role">辅导（报名剩余名额{{item.surplusQuota}}）</span>
              <span v-else class="role">辅导</span>
            </div>
          </div>
        </div>
      </div>
      <p class="line"></p>
      <div class="lessonMes">
        <span v-if="item.lessonCount" class="lesson_num">共{{item.lessonCount}}课时</span>

        <p v-if="item.salePrice">
          ¥
          <span>{{item.salePrice/100}}</span>
        </p>
        <span
          v-if="item.salePrice != item.originalPrice"
          class="lesson_cash"
        >¥{{item.originalPrice/100}}</span>
      </div>
    </div>
    <lesson_loading v-if="loadingLock" :status="status"></lesson_loading>
  </div>
</template>

<script>
import ajax from "@/api/ajax";
import utils from "@/assets/js/utils";
import lesson_loading from "@/components/common/lesson_loading.vue";
import titleBar from "@/components/common/titleBar.vue";
export default {
  name: "",
  data() {
    return {
      data: [],
      star: [0, 0, 0, 0, 0],
      loadingLock: true,
      status: "loading",
      title: "",
      groupId: 0,
      subject: 0
    };
  },
  methods: {
    initData: async function() {
      const _this = this;
      let token = utils.getQueryString("token");
      let version = utils.getQueryString("version");
      let source = utils.getQueryString("source");
      let groupId = utils.getQueryString("groupId");
      let subject = utils.getQueryString("subject");
      let grade = utils.getQueryString("grade");
      _this.groupId = groupId;
      _this.subject = subject;
      const [resp] = await ajax.all([
        ajax.get("/html5/learning-center/live-course-detail-list-in-group", {
          params: {
            token: token,
            version: version,
            source: source,
            groupId: groupId,
            subject: subject,
            grade: grade
          }
        })
      ]);
      if (resp.data.code == 99999) {
        console.log(resp.data.data);
        _this.loadingLock = false;
        _this.data = resp.data.data.list;
        _this.title = resp.data.data.title;
        if (_this.data.length == 0) {
          _this.loadingLock = true;
          _this.status = "empty";
        }
        _this.$nextTick(() => {
          window.scrollTo(0, 1);
          window.scrollTo(0, 0);
        });
      } else {
        _this.loadingLock = true;
        _this.status = "error";
      }
    },
    godetail: function(url, classNumber, courseId) {
      let self = this;
      let token = utils.getQueryString("token");
      let source = utils.getQueryString("source");
      let version = utils.getQueryString("version");
      utils.sendLog(
        {
          token: token,
          version: "3.3.0",
          source: "h5",
          extensionJson: {
            classNumber: classNumber,
            courseID: courseId
          }
        },
        "jz0335",
        function() {
          if (url) {
            window.location =
              url + "&payment=NewPayment&token=" + token + "&source=parentApp";
          } else {
            self.$router.push({
              path:
                "/lesson/lesson_detail?token=" +
                token +
                "&sourceId=" +
                classNumber +
                "&version=" +
                version +
                "&source=" +
                source
            });
          }
        }
      );
    }
  },
  components: {
    lesson_loading,
    titleBar
  },
  created: function() {
    let self = this;
    self.initData();
  }
};
</script>

<style lang="scss" scoped>
.select {
  margin-top: 0.88rem;
  background-color: #f5f5f5;
  .lessonItem {
    background-color: #fff;
    margin-bottom: 0.2rem;
    padding: 0 0.3rem;
    .item {
      padding: 0.5rem 0 0.4rem;
      // border-bottom: 1px solid #eeeeee;
      h2 {
        margin-bottom: 0.13rem;
        line-height: 0.4rem;
        font-family: PingFangSC-Medium;
        font-size: 0.34rem;
        color: #56586a;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .timeItem {
        span {
          &:last-child {
            margin-left: 0.1rem;
          }
        }
        line-height: 0.25rem;
        font-family: PingFangSC-Regular;
        font-size: 0.26rem;
        color: #9796a4;
      }
      .diffcult_item {
        margin-top: 0.3rem;
        height: 0.23rem;
        line-height: 0.23rem;
        span {
          height: 0.23rem;
          line-height: 0.23rem;
          margin-right: 0.1rem;
          font-family: PingFangSC-Regular;
          font-size: 0.24rem;
          color: #b6b6c1;
        }
        i {
          display: inline-block;
          width: 0.23rem;
          height: 0.24rem;
          margin-right: 0.06rem;
        }
        .on {
          background: url("../../assets/images/star_on.png") 0 0 / cover
            no-repeat;
        }
        .off {
          background: url("../../assets/images/star_off.png") 0 0 / cover
            no-repeat;
        }
      }
      .lesson_item_mes {
        margin-top: 0.36rem;
        height: 0.54rem;
        .box {
          float: left;
          &:first-child {
            width: 2.5rem;
          }
          img {
            width: 0.5rem;
            height: 0.5rem;
            border-radius: 50%;
            float: left;
          }
          .r_box {
            float: left;
            span {
              margin-left: 0.2rem;
              display: block;
              height: 0.22rem;
              line-height: 0.22rem;
              &:first-child {
                margin-bottom: 0.1rem;
              }
            }
            .name {
              font-family: PingFangSC-Regular;
              font-size: 0.24rem;
              color: #56546c;
            }
            .role {
              font-family: PingFangSC-Regular;
              font-size: 0.22rem;
              color: #b0b2c0;
            }
          }
        }
      }
    }
    .lessonMes {
      height: 0.8rem;
      line-height: 0.8rem;
      .lesson_num {
        font-family: PingFangSC-Medium;
        font-size: 0.26rem;
        color: #9796a4;
      }
      .lesson_cash {
        float: right;
        margin-right: 0.15rem;
        font-family: PingFangSC-Regular;
        font-size: 0.28rem;
        color: #b0b2c0;
        text-decoration: line-through;
      }
      p {
        display: inline;
        float: right;
        font-family: PingFangSC-Medium;
        font-size: 0.28rem;
        color: #ff714c;
        span {
          font-family: PingFangSC-Medium;
          font-size: 0.44rem;
          color: #ff714c;
        }
      }
    }
    .line {
      width: 100%;
      height: 1px;
      background: #eeeeee;
      transform: scale(1, 0.5);
    }
  }
}
</style>